import React, { Component } from 'react';
import { Link, Navigate } from "react-router-dom";
import API from "../../config/api";
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

export class BranchEdit extends Component {

    constructor(props) {
        super(props)
      
        this.state = {
          page: 1,
          folder_id: null,
          name: '',
          description: '',
          code: '',
          thumbnail: null,
          full_thumbnail: null,
          limit: 100,
          s: '',

          id: 1,
          quizs: [],
          all_categories: [],
          selected_categories: [],
          added_questions: [],

          data: [],
          percentage: 0,
          disable: true,
          // thumbnail: null,
          // image_url: "",
          // description: "",
          success: null,
          category_id: 1,
          categories: [],
        }
      }

      UNSAFE_componentWillMount() {
        this.getParam("id")
        this.getAllClass();
        this.getImage();
      }

      getParam(name) {
        let id = window.location.search.split(`${name}=`)[1]
        this.state.id = id;
        // this.setState({category_id : id})
        this.setState({})
        if (id) {
          this.getOneBranch();
        }
        // return 
      }

      getImage() {
        let url = API.getImage();
        this.setState({image_url : url})
      }

      getOneQuestion = async (id) => {
        try {
          let query = `id=${id}`
          let results = await API.getOneQuestion(query);
    
          let data = results.data.quiz;
          this.state.added_questions.push(data)
          this.setState({})
        } catch (error) {
          console.log(error)
        }
      }
    
      getOneBranch = async () => {
        try {
          let query = `id=${this.state.id}`
          let results = await API.getOneBranch(query);
    
          let data = results.data;

          // let all_quiz = data.quiz.quiz;
          // all_quiz.map(quiz => {
          //   this.getOneQuestion(quiz.id);
          // })

          this.setState({ 
            added_questions: data.classroom,
            data : data, 
            code: data.code,
            description: data.description,
            name: data.name,
            thumbnail: data.thumbnail_url
          });
    
        } catch (error) {
          console.log(error)
        }
      }

      getAllClass = async () => {
        try {
          let query = `page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
          let results = await API.getAllClass(query);
          let data = results.data;
          
          this.setState({ quizs : data.class, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      onSearch = async (event) => {
        event.preventDefault();
        let value = event.target.value;
        this.state.s = value;
        this.setState({});
        this.getAllClass()
      }

      onUploadProgress = (percentage) => {
        this.setState({ percentage: percentage})
        if (percentage ===100) {
          this.setState({ disable: false })
        }
      }

      onChangeFile = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        let name = event.target.name;
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            this.onUploadProgress
          );
          
          if (results){
            this.state.thumbnail = results.filename;
            this.state.full_thumbnail = results.full_url;
            // this.setState({ data: {
            //   ...this.state.data,
            //   [name]: results.filename,
            // }})
          }
    
        } catch (error) {
          console.log(error)
        }
      }
      handelInput = (event) => {
        event.preventDefault();
        let value = event.target.value;
        let name = event.target.name;
        
        this.setState({ data: {
          ...this.state.data,
          [name]: value
        }})
      }
      
      onRemoveQuestion(data){
        this.state.added_questions.splice(this.state.added_questions.indexOf(data), 1);
        this.state.quizs.push(data)
        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
    
      }

      onAddQuestion(data  = {}) {
        data.new = true;
        this.state.added_questions.unshift(data);
        
        // this.state.added_questions.push(data)
        // this.state.quizs.splice(this.state.quizs.indexOf(data), 1)

        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
      }
    
      handleSubmit = async (event) => {
        event.preventDefault();
        // let quis_id = [];
        let quiz_id = this.state.added_questions.map(quiz => {
          return quiz.id
        });

         let data = {
          id: this.state.id,
          name: this.state.name,
          description: this.state.description,
          code: this.state.code,
          // thumbnail: this.state.thumbnail,
          class_id: JSON.stringify(quiz_id)
         }

        // this.state.data.quiz_id = JSON.stringify(quiz_id)
        
        try {
          let results = await API.postOneBranch(data);
          if (results.result === 1){
            
            this.setState({ success: results.result })
          }
    
        } catch (error) {
          console.log(error)
        }
      }

  render() {
    return (
        <div className="col-12">
          <ToastContainer />
          {this.state.success && (
              <Navigate to="/branchindex?success=true" replace={true} />
          )}
            <form className="card" onSubmit={this.handleSubmit}>
                <h4 className="card-title"><strong>Branch</strong></h4>

                <div className="card-body row">

                    <div className="col-md-6">
                    <div className="form-group">
                        <label className="require" for="input-required">Name</label>
                        <input type="text" className="form-control" id="input-required" value={this.state.name} name='name' onChange={(event) => {
                          this.state.name = event.target.value;
                          this.setState({})
                        }} />
                    </div>
                    {/* <div className="form-group">  
                        <label for="inputState" className="col-form-label">Parent</label>
                        <select id="inputState" className="form-control">
                        <option>Short Film</option>
                        <option>Funny</option>
                        <option>Love story</option>
                        <option>Sad story</option>
                        </select>
                    </div> */}
                    
                    </div>


                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Description</label>
                        <input className="form-control" type="text" value={this.state.description} name='description' onChange={(event) => {
                          this.state.description = event.target.value;
                          this.setState({})
                        }} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Code</label>
                        <input className="form-control" type="text" value={this.state.code} name='code' onChange={(event) => {
                          this.state.code = event.target.value;
                          this.setState({})
                        }} />
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                    {/* <div className="col-md-6">
                    <div className="form-group">
                        <label>Thumbnail</label>
                        {this.state.full_thumbnail&& <img className='h-300px w-fullscreen' src={this.state.full_thumbnail} alt="..." />}
                        <br /><br />
                        <input type="file" data-provide="dropify" name='thumbnail_url' onChange={this.onChangeFile} />
                        <div class="progress">
                        < div class="progress-bar" role="progressbar" style={{width: this.state.percentage + "%", height: '10px'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"><strong>{this.state.percentage + "%"}</strong></div>
                          <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{width: this.state.percentage + "%"}}></div>
                        </div>
                    </div>
                    </div> */}
                    

                    
                </div>



                {/* add questions */}
                
                

                {/* <h4 className="card-title"><strong>All Classroom</strong></h4>
                <div className="card-body row">

                    <div className="col-md-6">



                    <div className="card-body">

                  <div className="flexbox mb-20">
                      <div className="lookup">
                        <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} />
                      </div>

                      <div className="btn-toolbar">
                        <div className="btn-group btn-group-sm">
                        
                        </div>

                        
                        </div>
                      </div>
                    <div>
                   </div>
                </div>

                    <div id="table-scroll">
                      <table className="table table-hover table-has-action table-bordered">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Level</th>
                            <th className="text-center w-150px">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                          this.state.quizs && this.state.quizs.map((quiz, index)=> {

                            let add_id = this.state.added_questions.map(q => q.id);

                            let style = {};

                            let added = false;

                            if (add_id.includes(quiz.id)) {
                              style = {background: '#d9d9d9'};
                              added = true;
                            }

                            return <tr style={style}>
                              <th scope="row">{( (this.state.page - 1) * 10) + (index+ 1)} </th>
                             
                              <td>{quiz.name}</td>
                              <td>{quiz.level}</td>

                              <td className="text-center table-actions">
                                <button className="btn btn-square  btn-primary" disabled={added} onClick={() => this.onAddQuestion(quiz)}><i className="fa fa-plus" ></i></button>
                                
                              </td>
                            </tr>
                            
                          })
                        }
                        </tbody>
                      </table>
                     </div>
                    </div>





                    <div className="col-md-6">
                      <div className="card-body">

                  <div className="flexbox mb-20">

                      <h5>Total classroom added:  <b className="text-success fw-500 w-80px">{this.state.added_questions.length}</b>&nbsp;<i class="fa fa-sitemap"> </i></h5>

                      <div className="btn-toolbar">
                        <div className="btn-group btn-group-sm">
                          
                        </div>

                        <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                          <div className="dropdown-menu dropdown-menu-right">
                            
                            <a className="dropdown-item" href="/">All</a>
                            <a className="dropdown-item" href="/">Reading</a>
                            <a className="dropdown-item" href="/">Listioning</a>
                          </div>
                        </div>
                        </div>
                      </div>
                    <div>
                   </div>
                </div>

                    <div id="table-scroll" style={{paddingTop: '4px'}}>          
                      <table className="table table-hover table-has-action table-bordered">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Level</th>
                            <th className="text-center w-150px">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                          this.state.added_questions && this.state.added_questions.map((quiz, index)=> {
                            return <tr style={{backgroundColor: quiz.new ? '#4ADA59' : ''}}>
                              <th scope="row">{( (this.state.page - 1) * 10) + (index+ 1)}</th>
                              
                              <td>{quiz.name}</td>
                              <td>{quiz.level}</td>
                              
                              <td className="text-center table-actions">
                                <Link className="btn btn-square btn-round btn-danger" title="View" onClick={() => this.onRemoveQuestion(quiz)}><i className="fa fa-minus"></i></Link>
                                
                              </td>
                            </tr>
                            
                          })
                        }
                        </tbody>
                      </table>
                     </div>
                    </div>

                </div>     */}


                <footer className="card-footer text-right">
                    <Link className="btn btn-secondary" to="/branchindex">Cancel</Link>
                    <button className="btn btn-primary" type="submit">Submit</button>
                </footer>
            </form>
        </div>
    )
  }
}

export default BranchEdit